import * as Sentry from '@sentry/vue'
import AudienceApi from '@/api/audience'
import UnleashService from '@/services/unleash'

const setPresentationAction = (context, payload) => {
  context.commit('setPresentation', payload)
}

const patchPresentationAction = (context, payload) => {
  context.commit('patchPresentation', payload)
}

const setActiveTabAction = (store, payload) => {
  store.commit('setActiveTab', payload.activeTab || payload)
}

const dispatchUpdateFeatureContextWithAwait = async (presentation, dispatch) => {
  // Tạo một Promise để đợi onReady hoàn thành
  // eslint-disable-next-line promise/avoid-new
  return new Promise((resolve) => {
    dispatch('featureToggles/updateFeatureContext', {
      userId: presentation.userId,
      properties: {
        uniqueAccessCode: presentation.uniqueAccessCode,
        email: presentation && presentation.user && presentation.user.email,
      },
      presentationCreatorEmail: presentation.creator.email,
      onReady: async () => {
        try {
          // Chạy hàm onReady khi nó được gọi
          resolve() // Resolve khi onReady hoàn tất
        } catch (error) {
          resolve() // Reject nếu có lỗi trong onReady
        }
      },
    })
  })
}

const getPresentationByCode = async ({ dispatch, rootGetters }, { uniqueAccessCode, params }) => {
  // eslint-disable-next-line no-useless-catch
  try {
    await UnleashService.waitForInitialization()
    const shouldEncrypt = rootGetters['featureToggles/canUseEncryptedSlideData']
    const response = await AudienceApi.getAudienceDataCDN(uniqueAccessCode, params, shouldEncrypt)
    const presentation = response.body.presentation || response.body
    // Need to update presentationCreatorEmail for the feature flag in order to correctly retrieve features based on the creator, so that both the presenter and the audience share the same flag and avoid errors.
    try {
      await dispatchUpdateFeatureContextWithAwait(presentation, dispatch)
    } catch (error) {
      Sentry.captureException(new Error('Update Context Creator Unleash Error'), {
        extra: {
          error,
          presentation,
        },
      })
    }
    return response
  // eslint-disable-next-line sonarjs/no-useless-catch
  } catch (error) {
    throw error
  }
}

export default {
  setPresentationAction,
  setPresentation: setPresentationAction,
  patchPresentationAction,
  setActiveTabAction,
  getPresentationByCode,
}
